"use client";

import {
	ListItem,
	NavigationMenu,
	NavigationMenuContent,
	NavigationMenuItem,
	NavigationMenuList,
	NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import cn from "@/lib/cn";
import Link from "next/link";
import { usePathname } from "next/navigation";

const MediaMenu = () => {
	const pathname = usePathname();
	const isActive =
		pathname.includes("news") || pathname.includes("events") || pathname.includes("blog");

	return (
		<NavigationMenu>
			<NavigationMenuList>
				<NavigationMenuItem>
					<NavigationMenuTrigger className={cn(isActive ? "text-brand-primary" : "text-gray-700")}>
						<Link
							href="/news"
							className={cn("z-10 rounded-md text-sm font-normal hover:text-brand-primary")}
						>
							News
						</Link>
					</NavigationMenuTrigger>
					<NavigationMenuContent>
						<ul className="grid gap-1 bg-white p-4">
							<ListItem title="News" href="/news" />
							<ListItem title="Events" href="/events" />
							<ListItem title="Blog" href="/blog" />
							<ListItem title="Submit press release" href="/news/press-release" />
						</ul>
					</NavigationMenuContent>
				</NavigationMenuItem>
			</NavigationMenuList>
		</NavigationMenu>
	);
};

export default MediaMenu;
